import { render, staticRenderFns } from "./MultiAddressInput.vue?vue&type=template&id=399cf71c&"
import script from "./MultiAddressInput.vue?vue&type=script&lang=js&"
export * from "./MultiAddressInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MultiAddressInput.vue"
export default component.exports